module.exports = __webpack_public_path__ + "img/35.b1795da9.jpg";